<template>
    <div class="materialDamage">
        <div class="tip" v-if="detail.assets.auditState=='15'||detail.assets.auditState=='40'||detail.assets.auditState=='90'">
            <span>*</span>
            审核退回原因：{{detail.assets.auditRemark}}
        </div>
        <div class="section">
            <div class="title">委托信息：</div>
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    案件性质:
                </div>
                <div class="input">
                    <el-select v-model="detail.assets.caseCome" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in caseComeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    委托主体:
                </div>
                <div class="input">
                    <el-select v-model="detail.assets.delegationType" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in delegationTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    委托方名称:
                </div>
                <div class="input">
                    <el-autocomplete
                        class="inline-input"
                        v-model="detail.assets.clientName"
                        :fetch-suggestions="querySearch"
                        placeholder=""
                        :trigger-on-focus="false"   
                        @select="handleSelect"
                        @keyup.enter.native="search"
                        size="small"
                        style="width:215px"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.name }}</div>
                        </template>
                    </el-autocomplete>
                </div>
            </div>
            
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    联系人:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.contacts" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    联系电话:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.clientPhone" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    联系地址:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.clientAddress" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    委托日期:
                </div>
                <div class="input">
                    <el-date-picker
                    v-model="detail.assets.entrustDate"
                    type="date"
                    size="small"
                    placeholder="选择日期">
                    </el-date-picker>
                    <!-- <el-input v-model="detail.assets.entrustDate" size="small" placeholder=""></el-input> -->
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span v-if="detail.assets.delegationType==1||detail.assets.delegationType==2">*</span>
                    <span v-else style="color:#ffffff">*</span>
                    报案号:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.inCaseNo" size="small" placeholder=""></el-input>
                </div>
            </div>

            <div class="item">
                <div class="label">
                    <span>*</span>
                    评估标的名称:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.targetName" size="small" placeholder="车牌/物损名称"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    标的所有人:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.targetUseby" size="small" placeholder="物主/车主"></el-input>
                </div>
            </div>

            <div class="item">
                <div class="label" style="width:150px">
                    委托评估鉴定事项:
                </div>
                <div class="textarea">
                    <el-input v-model="detail.assets.entrustMatter" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
               
            </div>

            <div class="item">
                <div class="label" style="width:150px">
                    是否需出具报告:
                </div>
                <div class="input">
                    <el-select v-model="isReport" placeholder="请选择" size="small" @change="isReportChange">
                        <el-option
                        :key="true"
                        label="否"
                        :value="true">
                        </el-option>
                        <el-option
                        :key="false"
                        label="是"
                        :value="false">
                        </el-option>
                    </el-select>
                </div>
               
            </div>
        </div>
        <div class="section">
            <div class="title">案件信息：</div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    案件名称:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.caseName" size="small" placeholder=""></el-input>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    委托项目:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.entrustedProject" size="small" placeholder=""></el-input>
                </div>
            </div> -->
            <div class="item">
                <div class="label">
                    报告编号:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.caseNo" size="small" placeholder="" disabled></el-input>
                </div>
            </div>
            <div class="item" v-if="detail.assets.delegationType==1||detail.assets.delegationType==2">
                <div class="label">
                    报案号:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.inCaseNo" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span> 
                    委托主体:
                </div>
                <div class="input">
                    <el-select v-model="detail.assets.delegationType" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in delegationTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    案件类型:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.assetsTypeStr" size="small" placeholder="" disabled></el-input>
                </div>
            </div> -->
            <div class="item">
                <div class="label">
                    案件状态:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.assetsStateStr" size="small" placeholder="" disabled></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    评估鉴定地址:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.entrustAddress" size="small" placeholder=""></el-input>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    事故地:
                </div>
                <div class="input">
                    <div class="input">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="detail.assets.crimeCityCode"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
            </div> -->
            <div class="item">
                <div class="label">
                    <span>*</span>
                    事故日期:
                </div>
                <div class="input">
                    <el-date-picker
                    v-model="detail.assets.damageTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    评估目的:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.evaluaPurpose" size="small" placeholder=""></el-input>
                </div>
            </div> -->
            <div class="item">
                <div class="label">
                    委托日期:
                </div>
                <div class="input">
                    <el-date-picker
                    v-model="detail.assets.entrustDate"
                    type="date"
                    size="small"
                    placeholder="选择日期">
                    </el-date-picker>
                    <!-- <el-input v-model="detail.assets.entrustDate" size="small" placeholder=""></el-input> -->
                </div>
            </div>
            <div class="item">
                <div class="label">
                    是否重新评估鉴定:
                </div>
                <div class="input">
                    <el-select v-model="detail.assets.entrustAgain" filterable placeholder="请选择" size="small">
                        <el-option key="是" label="是" value="是"></el-option>
                        <el-option key="否" label="否" value="否"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    评估鉴定用途:
                </div>
                <div class="input">
                    <el-select v-model="detail.assets.entrustUse" filterable placeholder="请选择" size="small">
                        <el-option
                        v-for="item in assessPurposeList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    <span>*</span>
                    车牌/物损名称:
                </div>
                <div class="input">
                    <el-input v-model="detail.materialDamage.damageRemark"  size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    物主/车主:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.entrustOwner"  size="small" placeholder=""></el-input>
                </div>
            </div> -->
            <div class="item" style="width:100%">
                <div class="label">
                    案件详情:
                </div>
                <div class="textarea textarea-all">
                    <el-input v-model="detail.assets.ajxq" type="textarea" :rows="3" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    评估鉴定风险提示:
                </div>
                <div class="textarea">
                    <el-input v-model="detail.assets.entrustRisk" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    备注:
                </div>
                <div class="textarea">
                    <el-input v-model="detail.assets.remark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>

            
            <!-- <div class="item">
                <div class="label">
                    受损物品描述:
                </div>
                <div class="input">
                    <el-input v-model="detail.materialDamage.damageRemark"  size="small" placeholder=""></el-input>
                </div>
            </div> -->
            <!-- <div class="item">
                <div class="label">
                    案件类型:
                </div>
                <div class="input">
                    <el-input v-model="detail.materialDamage.assetsTypeStr"  size="small" placeholder=""></el-input>
                </div>
            </div>
            <div style="width:100%"></div>
            <div class="item item-h">
                <div class="label">
                    评估报告标题:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.evaluationTitle"  size="small" placeholder=""></el-input>
                </div>
                <span>+评估报告书</span>
            </div>
            
            
            <div class="item">
                <div class="label">
                    委托方全称:
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.clientName" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            
            </div>
            <div class="item">
                <div class="label">
                    引言(<div class="tem" @click="lookTem('introduction')">模板</div>):
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.introduction" type="textarea" :rows="6" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    评估目的(<div class="tem" @click="lookTem('evaluaPurpose')">模板</div>):
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.evaluaPurpose" type="textarea" :rows="2" size="small" placeholder="" @focus="createEvaluaPurpose()"></el-input>
                </div>
            </div>
            
            <div class="item">
                <div class="label">
                    评估对象(<div class="tem" @click="lookTem('pgdx')">模板</div>):
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.pgdx" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label" style="width:170px">
                    保险责任认定依据(<div class="tem" @click="lookTem('bxzrdyj')">模板</div>):
                </div>
                <div class="textarea" style="width:530px">
                    <el-input v-model="detail.materialDamage.bxzrdyj" type="textarea" :rows="4" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label" style="width:170px">
                    价格评估依据(<div class="tem" @click="lookTem('jgpgyj')">模板</div>):
                </div>
                <div class="textarea" style="width:530px">
                    <el-input v-model="detail.materialDamage.jgpgyj" type="textarea" :rows="4" size="small" placeholder=""></el-input>
                </div>
                
            </div>
            <div class="item">
                <div class="label">
                    损失核定(<div class="tem" @click="lookTem('sshd')">模板</div>):
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.sshd" type="textarea" :rows="4" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    公估依据(<div class="tem" @click="lookTem('ggyj')">模板</div>):
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.ggyj" type="textarea" :rows="4" size="small" placeholder=""></el-input>
                </div>
            </div> -->
        </div>
        <!-- <div class="section">
            <div class="title">物损信息</div>
            
            <div class="item">
                <div class="label">
                    受损物品情况:
                </div>
                <div class="textarea">
                    <el-input v-model="detail.materialDamage.damageRemark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>
        </div> -->
        <div class="section" style="width:100%">
            <div class="title">费用信息：</div>
           
            <div class="item">
                <div class="label">
                    预估费用:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.yuGuFee" size="small" placeholder="" type="number"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    {{detail.assets.assetsType==1||detail.assets.assetsType==2||detail.assets.assetsType==3?'评估金额':''}}
                    {{detail.assets.assetsType==4||detail.assets.assetsType==5||detail.assets.assetsType==13?'核损金额':''}}
                    {{detail.assets.assetsType==6||detail.assets.assetsType==7||detail.assets.assetsType==8||detail.assets.assetsType==9||detail.assets.assetsType==10||detail.assets.assetsType==11||detail.assets.assetsType==12||detail.assets.assetsType==14||detail.assets.assetsType==15?'核损金额':''}}
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.jsFee" size="small" placeholder="" type="number"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    报损金额:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.bsFee" size="small" placeholder="" type="number"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    开票金额:
                </div>
                <div class="input">
                    <el-input v-model="detail.assets.fee" size="small" placeholder="" type="number"></el-input>
                </div>
            </div>
            
        </div>
       


        <div style="width:100%;margin-bottom:10px" v-if="isEdit">
            <el-button type="primary" icon="el-icon-circle-plus" @click="isAddImgTypeDialog = true">添加图片类型</el-button>
        </div>
        <div class="card">
            <el-tabs type="border-card" closable @edit="handleTabsEdit" v-model="mapTypeListIndex">
                <el-tab-pane v-for="(item, index) in mapTypeList" :key="index" :label="item.title" :name="item.name">
                    <div class="piclist">
                        <div class="pics">
                            <div class="pics-item" v-for="(mitem,mindex) in item.mapList" :key='mindex'>
                                
                                <img class="img" src="../../../assets/images/excel.png" @click="downloadReport(mitem.imgUrl)" v-if="mitem.type=='xls'||mitem.type=='xlsx'"/>
                                <img class="img" src="../../../assets/images/pdf.png" @click="downloadReport(mitem.imgUrl)" v-else-if="mitem.type=='pdf'" />
                                <img class="img" src="../../../assets/images/word.png" @click="downloadReport(mitem.imgUrl)" v-else-if="mitem.type=='doc'||mitem.type=='docx'"/>
                                <el-image
                                v-else
                                class="img"
                                :src="mitem.imgUrl+'?x-oss-process=image/resize,w_200'"
                                @click="showImg(mindex,item.mapList)"
                                >
                                </el-image>

                                <img src="../../../assets/images/icon08.png" mode="" class="close" @click="clearAssetsNalMap(index,mindex)" v-if="isEdit"/>
                                <div class="filename">
                                    {{mitem.title}}
                                </div>
                            </div>
                            <el-upload
                                :action="uploadUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :show-file-list="false"
                                :http-request="uploadDataUpdateAssetsNalMap"
                                v-if="isEdit"
                                >
                                <div class="uploadbtn" @click="mapTypeListIndex=item.name">
                                    <img src="../../../assets/images/icon10.png" alt="">
                                </div>
                            </el-upload>
                        </div>

                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div style="width:100%">
            <el-button type="primary" icon="el-icon-download" class="uploadbtn" @click="downloadImg" plain style="margin:10px 0">一键下载所有图片</el-button>
        </div>
        

        <div class="card" style="margin-bottom:10px">
            <el-tabs type="border-card">
                <el-tab-pane label="评估报告">
                    <div class="piclist">
                        <div class="pics">
                            <div class="pics-item" v-for="(item,index) in reportList" :key='index'>
                                <!-- :preview-src-list="assetsNalMap1" -->
                                <img class="img" src="../../../assets/images/excel.png" @click="downloadReport(item.imgUrl)" v-if="item.type=='xls'||item.type=='xlsx'"/>
                                <img class="img" src="../../../assets/images/pdf.png" @click="downloadReport(item.imgUrl)" v-else-if="item.type=='pdf'" />
                                <img class="img" src="../../../assets/images/word.png" @click="downloadReport(item.imgUrl)" v-else-if="item.type=='doc'||item.type=='docx'"/>
                                <el-image
                                v-else
                                class="img"
                                :src="item.imgUrl+'?x-oss-process=image/resize,w_200'"
                                @click="showImg(index,reportList)"
                                >
                                </el-image>
                                <img src="../../../assets/images/icon08.png" mode="" class="close" @click="reportDelete(index)" v-if="isEdit"/>
                                <div class="filename">
                                    {{item.name}}
                                </div>
                            </div>

                            <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="uploadReport"
                                :before-upload="beforeReportFile"
                                v-if="isEdit"
                                >
                                <div class="uploadbtn">
                                    <img src="../../../assets/images/icon10.png" alt="">
                                </div>
                            </el-upload>
                        </div>
                        
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <div class="card" style="margin-bottom:10px">
            <el-tabs type="border-card">
                <el-tab-pane label="归档资料">
                    <div class="piclist">
                        <div class="pics">
                            <div class="pics-item" v-for="(item,index) in archivedFileList" :key='index'>
                                <!-- :preview-src-list="assetsNalMap1" -->
                                <img class="img" src="../../../assets/images/excel.png" @click="downloadArchivedFile(item.imgUrl)" v-if="item.type=='xls'||item.type=='xlsx'"/>
                                <img class="img" src="../../../assets/images/pdf.png" @click="downloadArchivedFile(item.imgUrl)" v-else-if="item.type=='pdf'" />
                                <img class="img" src="../../../assets/images/word.png" @click="downloadArchivedFile(item.imgUrl)" v-else-if="item.type=='doc'||item.type=='docx'"/>
                                <img class="img" src="../../../assets/images/icon11.png" @click="downloadArchivedFile(item.imgUrl)"  v-else-if="item.type=='mp3'||item.type=='aac'"/>
                                <img class="img" src="../../../assets/images/icon12.png" @click="downloadArchivedFile(item.imgUrl)"  v-else-if="item.type=='mp4'||item.type=='avi'"/>
                                <img class="img" src="../../../assets/images/zip.png" @click="downloadArchivedFile(item.imgUrl)"  v-else-if="item.type=='rar'||item.type=='zip'"/>
                                <img class="img" :src="item.imgUrl" @click="showArchivedFile(item.imgUrl,archivedFileList)" v-else/>
                                <img src="../../../assets/images/icon08.png" mode="" class="close" @click="archivedFileDelete(index)" v-if="isEdit||isEditCost"/>
                                <div class="filename">
                                    {{item.name}}
                                </div>
                            </div>

                            <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="uploadArchivedFile"
                                :before-upload="beforeArchivedFile"
                                v-if="isEdit||isEditCost"
                                >
                                <div class="uploadbtn">
                                    <img src="../../../assets/images/icon10.png" alt="">
                                </div>
                            </el-upload>
                        </div>
                        
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        
        <div class="table" v-if="!isEdit">
            <el-table
                :data="detail.auditLog"
                border
                :header-cell-style="tableHeaderColor"
                >
                <el-table-column
                prop=""
                label="操作日志"
                align="center"
                >
                    <el-table-column
                    prop="operator"
                    label="操作人员"
                    align="center"
                    >
                    </el-table-column>
                    
                    <el-table-column
                    prop="content"
                    label="操作内容"
                    align="center"
                    >
                    </el-table-column>

                    <el-table-column
                    prop="creationTime"
                    label="操作日期"
                    align="center"
                    >
                    </el-table-column>
                </el-table-column>
                
                
            </el-table>
        </div>
        
        
        
       
        <div class="btn">
            <!-- <el-button type="primary" icon="el-icon-edit" class="uploadbtn" @click="operate()" v-if="detail.assets.assetsState==10">开 始 作 业</el-button> -->
            <el-button type="primary" icon="el-icon-back" class="uploadbtn" @click="backList">返回</el-button>

          
            <el-button type="primary" icon="el-icon-upload" class="uploadbtn" @click="submitCase(true,false)" >暂 存</el-button>

            <!-- <el-upload
                :action="uploadUrl"
                multiple
                :show-file-list="false"
                :http-request="uploadReport"
                v-if="isEdit"
                >
                <el-button type="primary" icon="el-icon-upload" class="uploadbtn" v-if="isEdit" style="margin:0 10px">上 传 报 告</el-button>
            </el-upload> -->
            <el-button type="success" icon="el-icon-download" class="uploadbtn" @click="downLoadAsset()" v-if="detail.assets.fileUrl">下 载 报 告</el-button>

            <el-button type="primary" icon="el-icon-upload" class="uploadbtn" @click="submitCase(false,true)" v-if="isEdit">提 交 案 件</el-button>
            <el-button type="primary" icon="el-icon-success" class="uploadbtn" @click="auditPass()" v-if="auditState==10">分公司审核通过</el-button>
            <el-button type="danger" icon="el-icon-error" class="uploadbtn" @click="auditNoPass()" v-if="auditState==10">分公司审核不通过</el-button>

            <el-button type="primary" icon="el-icon-success" class="uploadbtn" @click="auditPass()" v-if="auditState==30">总部审核通过</el-button>
            <el-button type="danger" icon="el-icon-error" class="uploadbtn" @click="auditNoPass()" v-if="auditState==30">总部审核不通过</el-button>

            <el-button type="primary" icon="el-icon-success" class="uploadbtn" @click="auditPass()" v-if="auditState==70">归档审核通过</el-button>
            <el-button type="danger" icon="el-icon-error" class="uploadbtn" @click="auditNoPass()" v-if="auditState==70">归档审核不通过</el-button>
            <el-button type="primary" icon="el-icon-tickets" class="uploadbtn" @click="stamp()" v-if="isStamp">申 请 用 印 开 票</el-button>


            <el-button type="primary" icon="el-icon-edit" v-if="this.detail.assets.auditState==50||this.detail.assets.auditState==90" @click="updateAssetsJSFeeTip()">提 交 审 核</el-button>
        </div>
       

    
    <div v-if="this.detail.assets.clientName=='天合富家能源股份有限公司' " style="justify-content: center; width: 100%;">
            <div  style="width: 100%; text-align: center;;">针对天合富家案件的操作：</div>

        <div class="btn">
            <el-button type="danger" icon="el-icon-document-delete" class="uploadbtn" @click="backThfjCase" v-if="this.detail.assets.assetsState=='10'" >审核资料不通过</el-button>
            <el-button type="success" icon="el-icon-folder-checked" class="uploadbtn" @click="passThfjCase"  v-if="this.detail.assets.assetsState=='10'">审核资料通过</el-button>
        <el-button type="warning" icon="el-icon-document" class="uploadbtn" @click="pushReport"  v-if="this.detail.assets.assetsState!=6 || this.detail.assets.assetsState!=5">推送报告至天合富家</el-button>
        </div>

    </div>
        <el-dialog :visible.sync="lossDialog" title="添加物损损失清单" width="770px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        项目名称:
                    </div>
                    <div class="input">
                        <el-input v-model="loss.project" size="small" placeholder="请输入" @input="lossInput"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单位:
                    </div>
                    <div class="input">
                        <el-input v-model="loss.company" size="small" placeholder="请输入" @input="lossInput"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单价:
                    </div>
                    <div class="input">
                        <el-input v-model="loss.unitPrice" size="small" placeholder="请输入" type="number" @input="lossInput(true)"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        数量:
                    </div>
                    <div class="input">
                        <el-input v-model="loss.number" size="small" placeholder="请输入" type="number" @input="lossInput(true)"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        评估价格:
                    </div>
                    <div class="input">
                        <el-input v-model="loss.price" size="small" placeholder="请输入" type="number" @focus="focusPrice()" @input="lossInput"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="textarea">
                        <el-input v-model="loss.remark" type="textarea" :rows="2" size="small" placeholder="请输入" @input="lossInput"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="lossDialog = false">关 闭</el-button>
                    <el-button type="primary" @click="addLoss">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="editLossDialog" title="编辑物损损失清单" width="770px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        项目名称:
                    </div>
                    <div class="input">
                        <el-input v-model="editLossData.project" size="small" placeholder="请输入" @input="lossInput"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单位:
                    </div>
                    <div class="input">
                        <el-input v-model="editLossData.company" size="small" placeholder="请输入" @input="lossInput"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单价:
                    </div>
                    <div class="input">
                        <el-input v-model="editLossData.unitPrice" size="small" placeholder="请输入" type="number" @input="lossInput(true,true)"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        数量:
                    </div>
                    <div class="input">
                        <el-input v-model="editLossData.number" size="small" placeholder="请输入" type="number" @input="lossInput(true,true)"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        评估价格:
                    </div>
                    <div class="input">
                        <el-input v-model="editLossData.price" size="small" placeholder="请输入" type="number" @focus="focusPrice(1)" @input="lossInput"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="textarea">
                        <el-input v-model="editLossData.remark" type="textarea" :rows="2" size="small" placeholder="请输入" @input="lossInput"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editLossDialog = false">关 闭</el-button>
                    <el-button type="primary" @click="editLossFun">确 定</el-button>
                </div>
            </div>
        </el-dialog>





        <el-dialog :visible.sync="isNoAudit" title="审核不通过" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="textarea">
                        <el-input v-model="remark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="noAudit">确认提交</el-button>
                </div>
            </div>
        </el-dialog>




        <el-dialog :visible.sync="isNoPassThfj" title="资料审核不通过" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        备注原因:
                    </div>
                    <div class="textarea">
                        <el-input v-model="thremark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="doNoPassThfjCase">确认提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="templateDialog" title="模板" width="770px">
            <div class="dialog">
                <el-input v-model="template" type="textarea" :rows="6" size="small" placeholder=""></el-input>
                <div class="template-footer">
                    <el-button type="primary" icon="el-icon-edit" class="uploadbtn" @click="affirmTemplate()">确认模板</el-button>
                </div>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="isAddImgTypeDialog" title="添加图片类型" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        图片类型:
                    </div>
                    <div class="input">
                        <el-input v-model="mapTypeAdd.title" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddImgTypeDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addImgType">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import {assetsTypeList,assetsStateList,delegationTypeList,caseComeList,assessPurposeList} from '../../../assets/selectList/assetsSelectList'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
import store from '../../../store'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            assessPurposeList:assessPurposeList,
            delegationTypeList:delegationTypeList,
            caseComeList:caseComeList,
            assetsTypeList:assetsTypeList,
            uploadUrl:'',
            editLossIndex:0,
            editLossDialog:false,
            editLossData:{},
            templateDialog:false,
            template:'',
            isNoAudit:false,
            isNoPassThfj:false,
            remark:'',
            thremark:'',
            detail:{
                assets:{},
                materialDamage:{},
                lossList:[],
                filesRequests:[],
            },
            assetsMaps1:[],
            assetsMaps2:[],
            assetsNalMap1:[
            'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210412/20210412164709827zh.jpg',
            'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210412/202104121646416EK7e.jpg',
            'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210412/20210412164845zShKf.jpg',
            'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210412/20210412164845d3kHQ.jpg'],
            assetsNalMap2:[],
            
            assetsNalMap3:[],
            assetsNalMap4:[],
            assetsNalMap5:[],
            lossDialog:false,
            loss:{},
            person:{},
            personTypeList:[
                {
                    label:'委托人',
                    value:10
                },{
                    label:'评估机构',
                    value:20
                },{
                    label:'公估师',
                    value:30
                },
            ],
            isEdit:0,
            isAudit:false,
            auditState:10,
            selectedOptions:[],
            Province:'',
            ProvinceCode:'',
            City:'',
            CityCode:'',
            options:provinceAndCityData,
            isNoSubmit:false,
            isStamp:false,
            uploadImgList:[],
            uploadImgNum:0,
            isImgListClear:false,
            imgType:0,
            total:0,
            key:'',
            isEditCost:false,

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            mapTypeList:[
                {
                    title: '委托书',
                    name: 30,
                    mapList: []
                },
                {
                    title: '相关单证',
                    name: 50,
                    mapList: []
                },
                // {
                //     title: '作业员资格证',
                //     name: 20,
                //     mapList: []
                // },
                {
                    title: '作业照',
                    name: 100,
                    mapList: []
                },
                {
                    title: '询价依据',
                    name: 101,
                    mapList: []
                }
            ],

            mapTypeListIndex:0,
            mapTypeAdd:{
                title:'',
            },
            isAddImgTypeDialog:false,

            reportList:[],

            archivedFileList:[],

            isReport:false,


        }
    },
    computed: {
        isUploadImgEnd() {
            return this.$store.state.global.isUploadImgEnd;
        }
    },
    watch: {
        // 'detail.lossList':function(ov){
        //     console.log(ov);
        //     this.total = 0;
        //     for(let index in ov){
        //         if(ov[index].project == '残值'){
        //             this.total = this.total - ov[index].price
        //         }else{
        //             this.total = this.total + ov[index].price
        //         }
        //     }
        // },
        "isUploadImgEnd":function(ov,nv){
            let _this = this;
            store.dispatch('global/setLoading', true);
            this.uploadImgNum = this.uploadImgNum + 1;
            
            if(this.uploadImgList.length == this.uploadImgNum){
                setTimeout(function(){
                    for(let index in _this.mapTypeList){
                        if(_this.mapTypeList[index].name == _this.mapTypeListIndex){
                            _this.mapTypeList[index].mapList = _this.mapTypeList[index].mapList.concat(_this.uploadImgList) 
                            _this.uploadImgList = [];
                            _this.uploadImgNum = 0;
                            store.dispatch('global/setLoading', false);
                            return;
                        }
                    }
                    store.dispatch('global/setLoading', false);
                },1000)
            }

        },
    },
    created(){
        this.queryAssetsMaterialDamage();
     
        //alert(this.detail.assets);

        this.isNoSubmit = this.$route.query.isNoSubmit;
        this.isAudit = this.$route.query.isAudit;
        this.auditState = this.$route.query.auditState;
        this.isEditCost = this.$route.query.isEditCost;
        if(this.$route.query.isStamp){
            this.isStamp = this.$route.query.isStamp;
        }
    },
    async mounted(){
        let res  = await api.queryBxCompnay({name:''});
        console.log(res);
        this.list = res.data.data;
    },
    methods:{
        isReportChange(e){
            if(this.isReport == false){
                if(this.detail.assets.remark == '无需出具报告'){
                    this.detail.assets.remark = ''
                }
            }else{
                this.detail.assets.remark = '无需出具报告'
            }
            this.$forceUpdate();
        },
        downloadReport(fileUrl){
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', fileUrl);
            elt.setAttribute('download', this.detail.assets.caseName);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        downloadArchivedFile(fileUrl){
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', fileUrl);
            elt.setAttribute('download', this.detail.assets.caseName);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        reportDelete(index){
            this.$confirm('确认删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.reportList.splice(index,1)
            }).catch(() => {
            });
        },
        archivedFileDelete(index){
            this.$confirm('确认删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.archivedFileList.splice(index,1)
            }).catch(() => {
            });
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(index,list){
            this.imgIndex = index;
            this.showBigImgList=[];
            for(let index in list){
                this.showBigImgList.push(list[index].imgUrl)
            }
            this.showBigImg = true;
        },
        // 开始作业
        operate(){
            this.id = this.detail.assets.id;
            if(this.detail.assets.yuGuFee<200&&this.detail.assets.yuGuFee){
                this.$message({
                    type: 'warning',
                    message: '预估金额不得小于200!'
                })
                return;
            }
            this.$confirm('是否开始作业此案件?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateAssetsState(20);
               
            }).catch(() => {
            });
        },
        updateAssetsJSFeeTip(){
            this.$confirm('提交后不能修改费用，确认无误是否提交?', '提示', {
                confirmButtonText: '确认提交',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateAssetsJSFee();
            }).catch((e) => {
            });
        },
        async updateAssetsJSFee(){
            let res = await api.updateAssetsJSFee({
                id:this.detail.assets.id,
                fee:parseFloat(this.detail.assets.fee),
                yuGuFee:parseFloat(this.detail.assets.yuGuFee),
                jsFee:parseFloat(this.detail.assets.jsFee),
                bsFee:parseFloat(this.detail.assets.bsFee),
            });
            if(res.data.code == '200'){
                
                this.isEditCost = false;
                this.submitCase(true,false);
                
                // this.queryAssetsMaterialDamage();
            }
        },
        stamp(){
            this.updateAssetsAuditState(this.detail.assets.id,35);
        },
        focusPrice(type){
            if(type){
                this.editLossData.price = this.accDiv(this.editLossData.number,this.editLossData.unitPrice);
                // this.editLossData.price = this.toFixed2(this.editLossData.price);
                if(this.editLossData.price%1 == 0){

                }else{
                    this.editLossData.price = this.toFixed2(this.editLossData.price);
                }
                this.$forceUpdate();
            }else{
                this.loss.price = this.accDiv(this.loss.number,this.loss.unitPrice);
                // this.loss.price = this.toFixed2(this.loss.price);
                if(this.loss.price%1 == 0){

                }else{
                    this.loss.price = this.toFixed2(this.loss.price);
                }
                this.$forceUpdate();
            }
        },
        accDiv(arg1,arg2){
            var m=0,s1=arg1.toString(),s2=arg2.toString();
            try{m+=s1.split(".")[1].length}catch(e){}
            try{m+=s2.split(".")[1].length}catch(e){}
            return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
        },
        toFixed2(num5){
            var numStr = num5.toString();
            var idx = numStr.indexOf('.');
            var res = Number(numStr.slice(0, idx + 3));
            console.log('res=',res);
            return res;
        },
        // 查看模板
        lookTem(key){
            this.templateDialog = true;
            let crimeCity = this.detail.assets.crimeCity.split(',')[0] + this.detail.assets.crimeCity.split(',')[1]
            this.key = key;
            if(key=='introduction'){
                this.template = '广州天信保险公估有限公司接受xxx委托，根据国家有关资产评估的规定，本着客观、独立、公正、科学的工作原则，按照公认的资产评估方法，根据xx使用现状综合评估法及市场先行鉴定评估价格。我司鉴定评估人员按照必要的程序，对委托鉴定评估xx进行了全国xxx价格查询及本地市场调查与询证、评定估算等工作，对委托鉴定评估xxx在评估基准日'+this.getTime(this.detail.assets.damageTime)+'所表现的xxx评估价格作出了公允反映。';
            }
            if(key=='evaluaPurpose'){
                this.template = '为xxxxxxxxx损失情况进行评估价格。';
            }if(key=='pgdx'){
                this.template = '本次评估价格对象：xxxxxxxxxxxxxxxxxxxxxxxxxxx。';
            }if(key=='bxzrdyj'){
                this.template = '事故责任认定及依据如下：根据委托方提供的xxxxxx出具道路交通事故认定书（第440704520200503012号）显示，xxxx年xx月xx日xx时xxx（驾驶证号：xxxxxxxxxxxx）驾驶车辆xxxxxx在xxxxxxxxxxxxxxxxxxxxxx因行驶不慎时撞房屋，造成房屋及车辆受损，交警判定处理本次事故由xxxxxx负全部责任。房屋损失为本次事故造成。';
            }if(key=='sshd'){
                this.template = 'xxxxxxxxx损失如下：经对评估xxxx损失情况勘察，核定损失金额如下：核定工时材料费：xxxxxx元，（其中项目：xx项；含人工、检查费、材料费、税金）（附件：损失明细单），共计人民币：总计金额：xxxxxxxxxxxxxxxxx（xxxxxxxxxxxxxxx）。';
            }if(key=='ggyj'){
                this.template = '根据我司评估师实地勘察，结合'+crimeCity+'当地xxxx工时标准，依据《中华人民共和国价格法》、《中华人民共和国资产评估法》、《中华人民共和国道路交通安全法实施条例》、《交通事故处理程序规定》、交通事故责任认定书等作出此报告。';
            }if(key=='jgpgyj'){
                this.template = '1、《中华人民共和国价格法》；'+'\n\n'+
                '2、《中华人民共和国资产评估法》；'+'\n\n'+
                '3、中价协事字(2020)40号《关于印发<交通事故车辆及财物损失价格鉴证评估技术规范>的通知》；'+'\n\n'+
                '4、《广东省道路交通事故车物损失价格鉴定操作规程》；'+'\n\n'+
                '5、广东省高级人民法院授予我司司法委托专业机构资质批准文号粤高法[2018]223号；'+'\n\n'+
                '6、广东省价格认定相关技术参数参照标准(2018年)；'+'\n\n'+
                '7、中价协事字(2020)31号《关于印发<价格鉴证评估执业规范>的通知》；'+'\n\n'+
                '8、委托评估委托书及相关资料；'+'\n\n'+
                '9、市场价格调查情况；'+'\n\n'+
                '10、实物勘查情况；'+'\n\n'+
                '11、粤交路[1998] 38 号'
            }
        },
        // 确认模板
        affirmTemplate(){
            this.detail.materialDamage[this.key] = this.template;
            this.templateDialog = false;
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        auditPass(){
            // this.id = row.id;
            this.$confirm('是否审核通过?', '提示', {
                confirmButtonText: '审核通过',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log(this.auditState);
                if(this.auditState==10){
                    this.updateAssetsAuditState(this.detail.assets.id,30);
                }else if(this.auditState==30){
                    this.updateAssetsAuditState(this.detail.assets.id,50);
                }else if(this.auditState==70){
                    this.updateAssetsAuditState(this.detail.assets.id,80);
                }
                this.queryAssetsMaterialDamage();
            }).catch((e) => {
                // this.isNoAudit = true;
            });
        },
        auditNoPass(){
            this.isNoAudit = true;
        },
        backThfjCase(){
            this.isNoPassThfj = true;
        },
        noAudit(){
            if(this.auditState==10){
                this.updateAssetsAuditState(this.detail.assets.id,15);
            }else if(this.auditState==30){
                this.updateAssetsAuditState(this.detail.assets.id,40);
            }else if(this.auditState==70){
                    this.updateAssetsAuditState(this.detail.assets.id,90);
                }
            this.queryAssetsMaterialDamage();
        },
        doNoPassThfjCase(){
            this.$confirm('是否操作审核不通过?', '提示', {
                confirmButtonText: '审核不通过',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                
                let res=api.notifySupplement({
                        ggNo:this.detail.assets.inCaseNo,
                        info: this.thremark
                    });
                    this.thremark='';
                    this.isNoPassThfj=false;
                    if(res.data.code == '200'){
                    this.$message({
                    type: 'success',
                    message: '操作成功!'
                });

            }else{
                //this.isNoPassThfj=false;
                
            }

            }).catch((e) => {
                // this.isNoAudit = true;
            });

        },
        passThfjCase(){
            this.$confirm('是否操作审核通过?', '提示', {
                confirmButtonText: '审核通过',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                  let res=api.pushStatus({
                        ggNo:this.detail.assets.inCaseNo,
                        remark: ''
                    });

                    if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });

            }


            }).catch((e) => {
                // this.isNoAudit = true;
            });
        },
        pushReport(){
            this.$confirm('是否推送报告至天合富家?', '提示', {
                confirmButtonText: '审核通过',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                  let res=api.pushReports({
                        ggNo:this.detail.assets.inCaseNo,
                        remark: ''
                    });

                    if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });

            }


            }).catch((e) => {
                // this.isNoAudit = true;
            });
        },
        async updateAssetsAuditState(id,state){
            let res = await api.UpdateAssetsAuditState({
                "id": id,
                "auditState": state,
                "auditRemark": this.remark,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.remark = '';
                this.isNoAudit = false;
                this.$router.go(-1)
            }
        },
        createEvaluaPurpose(){
            // this.detail.materialDamage.evaluaPurpose = '为'+this.detail.materialDamage.owner+'提供车牌'+this.detail.materialDamage.licenseNo+'的车辆损失情况进行损失评估价格。';
            // console.log(this.detail.materialDamage.evaluaPurpose);
            // 为肇庆市广宁县潭布水寨路段广电线路工程损失情况进行评估价格。
            // this.$forceUpdate();
        },
        async queryAssetsMaterialDamage(){
            let res = await api.QueryAssetsMaterialDamage(this.$route.query.id);
            this.detail = res.data.data;


        if(this.detail.assets.assetsState==36){

                this.isEdit =1;
        }
        else{

            this.isEdit = this.$route.query.isEdit;
        }
           
 

            this.reportList = this.detail.filesRequests?this.detail.filesRequests:[];
            if(this.detail.atlasMapResponses.length>0){
                this.mapTypeList = this.detail.atlasMapResponses;
            }
            

            if(this.mapTypeList.length>0){
                this.mapTypeListIndex = this.mapTypeList[0].name;
            }else{
                this.mapTypeListIndex = 30;
            }

            this.archivedFileList = this.detail.archivedFileRequests?this.detail.archivedFileRequests:[];

            // let crimeCityCode = [this.detail.assets.crimeCityCode.split(',')[0],this.detail.assets.crimeCityCode.split(',')[1]];
            // this.detail.assets.crimeCityCode = crimeCityCode;
            
            // let map1=[];
            // this.assetsNalMap1 = [];
            // for(let index in this.detail.assetsNalMap){
            //     if(this.detail.assetsNalMap[index].assetsNulMapType==10){
            //         map1.push(this.detail.assetsNalMap[index].path)
            //     }else if(this.detail.assetsNalMap[index].assetsNulMapType==20){
            //         this.assetsNalMap2.push(this.detail.assetsNalMap[index].path)
            //     }else if(this.detail.assetsNalMap[index].assetsNulMapType==30){
            //         this.assetsNalMap3.push(this.detail.assetsNalMap[index].path)
            //     }else if(this.detail.assetsNalMap[index].assetsNulMapType==50){
            //         this.assetsNalMap4.push(this.detail.assetsNalMap[index].path)
            //     }else if(this.detail.assetsNalMap[index].assetsNulMapType==100){
            //         this.assetsNalMap5.push(this.detail.assetsNalMap[index].path)
            //     }
            // }
            // if(map1.length>0){
            //     console.log(11);
            //     this.assetsNalMap1 = map1;
            // }
            this.$forceUpdate();
            if(this.detail.assets.assetsState==10&&this.isEdit){
                this.operate();
            }
        },
        getTime(time){
            let d = new Date(time);
            let year = d.getFullYear()>9?d.getFullYear():'0'+d.getFullYear();
            let month = (d.getMonth()+1)>9?(d.getMonth()+1):('0'+(d.getMonth()+1));
            let day = d.getDate()>9?d.getDate():'0'+d.getDate();

            // let hours = d.getHours()>9?d.getHours():'0'+d.getHours();
            // let minutes = d.getMinutes()>9?d.getMinutes():'0'+d.getMinutes();
            // let seconds = d.getSeconds()>9?d.getSeconds():'0'+d.getSeconds();

            
            // return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
            return year + '年' + month + '月' + day + '日'
        },
       
        clearAssetsNalMap(i,j){
            this.mapTypeList[i].mapList.splice(j,1)
        },
        addLoss(){
            this.loss.assetsId = this.detail.assets.id
            this.loss.number = parseFloat(this.loss.number);
            this.loss.price = parseFloat(this.loss.price);
            this.detail.lossList.push(this.loss);
            // this.lossDialog = false;
            // this.loss = {};

            let project = this.loss.project;
            let company = this.loss.company;
            let unitPrice = this.loss.unitPrice;
            let number = this.loss.number;
            let price = this.loss.price;
            let remark = this.loss.remark;
            this.loss = {};
            this.loss.project = project
            this.loss.company = company
            this.loss.number = number
            this.loss.unitPrice = unitPrice
            this.loss.remark = remark
            this.loss.price = price
        },
        deleteLoss(row,index){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.detail.lossList.splice(index,1);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
       
       
        //上传前拦截
        async beforeUpload(file){
            console.log(file);
            // console.log(file.name);
            var msg=file.name.substring(file.name.lastIndexOf('.')+1)
            msg = msg.toLowerCase();
            if(msg != 'jpg' && msg != 'png' && msg != 'jpeg' && msg != 'xls' && msg != 'xlsx' && msg != 'pdf' && msg != 'doc' && msg != 'docx') {
                this.$message({
                    message: '上传文件只能是 jpg、png、jpeg、xls、xlsx、pdf、doc、docx格式!',
                    type: 'warning'
                });
                return false;
            }
        },
        
        // async uploadDataUpdateAssetsNalMap1(file){
        //     let res = await api.uploadOther(file.file);
        //     this.assetsNalMap1.push(res);
        //     return;
        // },
        // async uploadDataUpdateAssetsNalMap2(file){
        //     let res = await api.uploadOther(file.file);
        //     this.assetsNalMap2.push(res);
        //     return;
        // },
        // async uploadDataUpdateAssetsNalMap3(file){
        //     this.imgType = 3;
        //     let res = await api.uploadOtherSort(file.file);
        //     // this.assetsNalMap3.push(res);
        //     this.uploadImgList.push(res);
        //     return;
        // },
        // async uploadDataUpdateAssetsNalMap4(file){
        //     this.imgType = 4;
        //     let res = await api.uploadOtherSort(file.file);
        //     // this.assetsNalMap4.push(res);
        //     this.uploadImgList.push(res);
        //     return;
        // },
        // async uploadDataUpdateAssetsNalMap5(file){
        //     this.imgType = 5;
        //     let res = await api.uploadOtherSort(file.file);
        //     // this.assetsNalMap5.push(res);
        //     this.uploadImgList.push(res);
        //     return;
        // },
        // 上传文件
        async uploadDataUpdateAssetsNalMap(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.toLowerCase();

            let res = await api.uploadOtherSort(file.file);
            this.uploadImgList.push({
                "imgUrl":res,
                "sort": null,
                "title":name,
                "type":fileType,
            });
            return;
        },
        // 编辑提交
        async submitCase(isZanCun,isSubmit){
            if(!this.detail.assets.delegationType){
                this.$message({
                    type: 'warning',
                    message: '请填写委托类型!'
                });
                return;
            }
            if(!this.detail.assets.clientName){
                this.$message({
                    type: 'warning',
                    message: '请填写委托方名称!'
                });
                return;
            }
            if(!this.detail.assets.contacts){
                this.$message({
                    type: 'warning',
                    message: '请填写联系人!'
                });
                return;
            }
            if(!this.detail.assets.clientPhone){
                this.$message({
                    type: 'warning',
                    message: '请填写联系电话!'
                });
                return;
            }
            if(!this.detail.assets.clientAddress){
                this.$message({
                    type: 'warning',
                    message: '请填写联系地址!'
                });
                return;
            }
            if(!this.detail.assets.caseName){
                this.$message({
                    type: 'warning',
                    message: '请填写案件名称!'
                });
                return;
            }
            // if(!this.detail.assets.entrustedProject){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写委托项目!'
            //     });
            //     return;
            // }
            if(!this.detail.assets.inCaseNo&&this.detail.assets.delegationType==1){
                this.$message({
                    type: 'warning',
                    message: '请填写报案号!'
                });
                return;
            }
            // if(!this.detail.assets.crimeCityCode){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写事故地!'
            //     });
            //     return;
            // }
            if(!this.detail.assets.damageTime){
                this.$message({
                    type: 'warning',
                    message: '请填写事故日期!'
                });
                return;
            }
            if(!this.detail.assets.entrustDate){
                this.$message({
                    type: 'warning',
                    message: '请填写委托日期!'
                });
                return;
            }


            
            if(!this.detail.assets.operatorId){
                this.$message({
                    type: 'warning',
                    message: '请填写作业人员!'
                });
                return;
            }
            if(!this.detail.assets.yuGuFee){
                this.$message({
                    type: 'warning',
                    message: '请填写预估公估费!'
                });
                return;
            }
            if(!this.detail.assets.jsFee&&this.detail.assets.jsFee!=0){
                this.$message({
                    type: 'warning',
                    message: '请填写金额!'
                });
                return;
            }
            if(this.detail.assets.bsFee=="undefined" || this.detail.assets.bsFee==null){//&&this.detail.assets.bsfee!=0
                this.$message({
                    type: 'warning',
                    message: '请填写报损金额!'
                });
                return;
            }
            if(this.detail.assets.fee==""&&this.detail.assets.fee!=0){
                this.$message({
                    type: 'warning',
                    message: '请填写开票金额!'
                });
                return;
            }
            if(this.detail.assets.yuGuFee<200){
                this.$message({
                    type: 'warning',
                    message: '预估公估费不能低于200!'
                });
                return;
            }

            let re=/(\n(?=(\n+)))+/g;

            if(this.detail.materialDamage.jgpgyj){
                this.detail.materialDamage.jgpgyj = this.detail.materialDamage.jgpgyj.replace(re,"\r  ")
            }
            // for(let index in this.detail.lossList){
            //     console.log(this.detail.lossList[index]);
            //     this.detail.lossList[index].sort = parseFloat(index);
            // }
            // this.detail.materialDamage.statAppra = '1．我们在执行本资产评估业务中，遵循相关法律法规和资产评估准则，恪守独立、客观和公正的原则；根据我们在执业过程中收集的资料，评估报告陈述的内容是客观的，我们对评估结论合理性承担相应的法律责任。'+'\r\n\n'+
            // '2．本报告涉及的评估对象和评估范围清单由委托方、被评估单位（或者产权持有单位）申报并经其签章确认；评估所需必要资料由其提供并保证所提供资料的真实性、合法性、完整性。'+'\r\n\n'+
            // '3．我们与评估报告中的评估对象没有现存或者预期的利益关系；与相关当事方没有现存或者预期的利益关系，对相关当事方不存在偏见。'+'\r\n\n'+
            // '4．我们对评估报告中已发现的问题进行了如实披露且已提请委托方及相关当事方完善资料以满足出具评估报告的要求，但评估报告中对法律权属的陈述不代表评估师对法律权属提供保证或鉴证意见。'+'\r\n\n'+
            // '5．评估报告使用者应正确理解使用本《'+this.detail.assets.evaluationTitle+'损失评估报告》，评估师和评估机构对委托方和其他评估报告使用者不当使用《'+this.detail.assets.evaluationTitle+'损失评估报告》所造成的后果不承担责任。'+'\r\n\n'+
            // '6．除法律、法规规定以及相关当事方另有约定外，未征得本评估机构同意，评估报告的全部或部分内容不得被摘抄、引用或披露于公开媒体。'
            // this.detail.materialDamage.appraisalDate ='评估基准日'+this.getTime(this.detail.assets.damageTime)+'，评估价格过程中所采用的各种价格依据，以基准日为准。'
            // this.detail.materialDamage.evaluationPrin = '严格遵循“客观性、独立性、公正性、科学性”原则。'
            
            // this.detail.materialDamage.pgbgflxl = '1、本项损失价格评估结论自评估报告日起，有效期壹年。'+'\r\n\n'+
            // '2、当评估目的在有效期内实现时，本损失鉴定价格评估结果作为价值参考依据，超过有效期，需重新评估。另外在评估有效期内评估'+this.detail.assets.evaluationTitle+'受到任何损坏价值发生变化时，委托方需重新委托损失鉴定评估机构重新鉴定评估。'+'\r\n\n'+
            // '3、损失鉴定评估报告书的使用权归委托方所有，不适用于其他目的。'
            this.detail.assetsMaps = [];
            this.detail.assetsNalMap = [];
            let sort = 0;
            if(isZanCun){
                this.detail.assets.zanCun = true;
            }else{
                this.detail.assets.zanCun = false;
            }
            if(this.detail.assets.yuGuFee<200&&this.detail.assets.yuGuFee){
                this.$message({
                    type: 'warning',
                    message: '预估金额不得小于200!'
                })
                return;
            }else{
                this.detail.assets.yuGuFee = parseFloat(this.detail.assets.yuGuFee);
            }
         

            this.detail.assets.fee = parseFloat(this.detail.assets.fee);
            this.detail.assets.jsFee = parseFloat(this.detail.assets.jsFee);
            this.detail.assets.bsFee = parseFloat(this.detail.assets.bsFee);
            
            for(let index in this.mapTypeList){
                this.mapTypeList[index].name = this.mapTypeList[index].name+'';
                this.mapTypeList[index].assetsId = this.detail.assets.id;
                this.mapTypeList[index].sort = parseFloat(index);

                for(let cindex in this.mapTypeList[index].mapList){
                    console.log(this.mapTypeList[index].mapList);
                    this.mapTypeList[index].mapList[cindex].sort = parseFloat(cindex)
                    this.mapTypeList[index].mapList[cindex].id = 0;
                }
            }
            // for(let index in this.assetsNalMap1){
            //     this.detail.assetsNalMap.push({
            //         "assetsId": this.detail.assets.id,
            //         "path": this.assetsNalMap1[index],
            //         "assetsNulMapType": 10,
            //         "sort": sort
            //     });
            //     sort++;
            // }
            // for(let index in this.assetsNalMap2){
            //     this.detail.assetsNalMap.push({
            //         "assetsId": this.detail.assets.id,
            //         "path": this.assetsNalMap2[index],
            //         "assetsNulMapType": 20,
            //         "sort": sort
            //     });
            //     sort++;
            // }
            // for(let index in this.assetsNalMap3){
            //     this.detail.assetsNalMap.push({
            //         "assetsId": this.detail.assets.id,
            //         "path": this.assetsNalMap3[index],
            //         "assetsNulMapType": 30,
            //         "sort": sort
            //     });
            //     sort++;
            // }
            // for(let index in this.assetsNalMap4){
            //     this.detail.assetsNalMap.push({
            //         "assetsId": this.detail.assets.id,
            //         "path": this.assetsNalMap4[index],
            //         "assetsNulMapType": 50,
            //         "sort": sort
            //     });
            //     sort++;
            // }
            // for(let index in this.assetsNalMap5){
            //     this.detail.assetsNalMap.push({
            //         "assetsId": this.detail.assets.id,
            //         "path": this.assetsNalMap5[index],
            //         "assetsNulMapType": 100,
            //         "sort": sort
            //     });
            //     sort++;
            // }
            // let crimeCityCode = ''
            // for(let index in this.detail.assets.crimeCityCode){
            //     if(index == 0){
            //         crimeCityCode =this.detail.assets.crimeCityCode[index]
            //     }else{
            //         crimeCityCode = crimeCityCode+','+this.detail.assets.crimeCityCode[index]
            //     }
            // }
            // let oldCrimeCityCode = this.detail.assets.crimeCityCode
            // this.detail.assets.crimeCityCode = crimeCityCode;
            this.detail.filesRequests = this.reportList;
            this.detail.assetAtlasMap = this.mapTypeList;
            this.detail.archivedFileRequests = this.archivedFileList;

                console.log(this.detail);
            let res = await api.UpdateAssetsMaterialDamage(this.detail);
            // this.detail.assets.crimeCityCode = oldCrimeCityCode;
            if(res.data.code == '200'){
                if(!isSubmit){
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                    if(this.isReport){
                        
                        this.updateAssetsAuditState(this.detail.assets.id,100);
                    }
                }else{
                    if(this.isReport){
                        this.updateAssetsAuditState(this.detail.assets.id,100);
                    }else{
                        this.updateAssetsAuditState(this.detail.assets.id,10);
                    }
                }
            }
        },
        // 更新案件状态
        async updateAssetsState(state){
            console.log(state);
            let res = await api.UpdateAssetsState({
                "id": this.detail.assets.id,
                "assetsState": state,
                "remark": this.remark
            });
            if(res.data.code == '200'){
                
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
                if(state==20){
                    // this.queryAssetsMaterialDamage();
                    this.isEdit = true;
                }else{
                    this.$router.go(-1)
                }
            }
        },
        // 地区选择
        handleRegionChange(codeArray){
            console.log(codeArray);
            console.log(this.detail.assets.crimeCity);
            if(codeArray[0]){
                this.Province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.CrimeCity = CodeToText[codeArray[1]]
            }
        },
        // 下载图片
        async downloadImg(){
            let res = await api.downLoadFile({
                "assetsId": this.detail.assets.id,
                "zipName": "物损图片"
            });
        },
        lossInput(isX,isEdit){
            if(isX){
                this.focusPrice(isEdit);
            }
            this.$forceUpdate();
        },
        editLoss(row,index){
            console.log(row);
            console.log(index);
            this.editLossIndex = index
            this.editLossDialog = true;
            this.editLossData = row;
        },
        editLossFun(){
            this.editLossData.number = parseFloat(this.editLossData.number);
            this.editLossData.price = parseFloat(this.editLossData.price);
            this.detail.lossList[this.editLossIndex] = this.editLossData;
            this.editLossDialog = false;
            this.$forceUpdate();
            this.$set(this.detail.lossList, this.editLossIndex, this.detail.lossList[this.editLossIndex]);
        },
        // 上传报告
        async uploadReport(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.toLowerCase();
            let res = await api.uploadOther(file.file,{},name);
            this.reportList.push({
                name:name,
                type:fileType,
                imgUrl:res,
                assetsID:this.detail.assets.id,
            })


            this.$forceUpdate();
        },
        // 上传归档资料
        async uploadArchivedFile(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.toLowerCase();
            let res = await api.uploadOther(file.file,{},name);
            this.archivedFileList.push({
                name:name,
                type:fileType,
                imgUrl:res,
                assetsID:this.detail.assets.id,
            })
            this.$forceUpdate();
        },
        // 上传拦截
        beforeArchivedFile(file){
            var msg=file.name.substring(file.name.lastIndexOf('.')+1)
            msg = msg.toLowerCase();
            if(msg != 'jpg' && msg != 'png' && msg != 'jpeg' && msg != 'mp3' && msg != 'aac' && msg != 'mp4' && msg != 'avi' && msg != 'pdf' && msg != 'xls' && msg != 'xlsx' && msg != 'doc' && msg != 'docx' && msg != 'zip' && msg != 'rar') {
                this.$message({
                    message: '上传文件只能是 jpg、png、jpeg、mp3、aac、mp4、avi、pdf、xls、xlsx、doc、docx格式!',
                    type: 'warning'
                });
                return false;
            }
        },
        beforeReportFile(file){
            var msg=file.name.substring(file.name.lastIndexOf('.')+1)
            msg = msg.toLowerCase();
            if(msg != 'jpg' && msg != 'png' && msg != 'jpeg' && msg != 'pdf' && msg != 'xls' && msg != 'xlsx' && msg != 'doc' && msg != 'docx') {
                this.$message({
                    message: '上传文件只能是 pdf、xls、xlsx、doc、docx格式!',
                    type: 'warning'
                });
                return false;
            }
        },
        // 下载文档
        async downLoadAsset(){
            this.$message({
                type: 'success',
                message: '正在下载，请稍等!'
            })
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', this.detail.assets.fileUrl);
            elt.setAttribute('download', this.detail.assets.caseName);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        // 返回列表
        backList(){
            this.$router.go(-1);
        },

        // 输入自动匹配
        async querySearch(queryString, cb){
            let list = this.list;
            console.log(queryString);
            let results = queryString ? list.filter(this.createFilter(queryString)) : list;
            console.log(results);
            cb(results);
        },
        handleSelect(e){
            console.log(e);
            this.assets.clientName = e.name;
        },
        createFilter(queryString) {
            return (list) => {
                return (list.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        // 添加图片类型
        addImgType(){
            this.isAddImgTypeDialog = false;
            this.mapTypeList.push({
                title: this.mapTypeAdd.title,
                name: this.mapTypeList.length?parseFloat(this.mapTypeList[this.mapTypeList.length-1].name) + 1:0,
                mapList: []
            })
            console.log(this.mapTypeList);
            this.$forceUpdate();
        },
        showArchivedFile(path,list){
            this.showBigImgList=[];
            for(let index in list){
                if(list[index].type=='jpg'||list[index].type=='png'||list[index].type=='gif'||list[index].type=='jpeg'||list[index].type=='JPG'||list[index].type=='PNG'||list[index].type=='GIF'||list[i].fileType=='JPEG'){
                    this.showBigImgList.push(list[index].imgUrl);
                    if(path == list[index].imgUrl){
                        this.imgIndex = this.showBigImgList.length-1
                    }
                }
            }
            this.showBigImg = true;
        },
        handleTabsEdit(e){
            
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                for(let index in this.mapTypeList){
                    if(this.mapTypeList[index].name == e){
                        this.mapTypeList.splice(index,1);
                    }
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
            
        }


    }
    
}
</script>

<style lang="scss" scoped>
   
    .materialDamage{
        display: flex;
        flex-wrap: wrap;
        .section{
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            border: 1px solid #DEDEDE;
            margin-bottom: 10px;
            padding-bottom: 10px;
            background-color: #FFFFFF;
            .title{
                width: 100%;
                font-weight: bold;
                font-size: 16px;
                margin-bottom: 12px;
                background-color: #DEDEDE;
                padding:8px 15px;
            }
        }
        .tip{
            width: 100%;
            padding:10px 8px;
            font-size: 14px;
            display: flex;
            align-items: center;
            line-height: 14px;
            span{
                color: red;
                font-size: 18px;
                line-height: 18px;
            }
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 4px;
                width: 120px;
                display: flex;
                span{
                    color: red;
                }
                .tem{
                    color:#409EFF;
                    cursor: pointer;
                }
            }
            .input{
                width: 215px;
            }
            /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner{
                width: 215px;
            }
            .textarea{
                width: 580px;
            }
        }
        .item-h{
            display: flex;
            align-items: center;
            width: 700px;
            .input{
                width: 366px;
            }
            span{
                margin-left: 5px;
            }
        }
        .total{
            width: 100%;
            display: flex;
        }
        .totalprice{
            margin-right: 40px;
            font-size: 14px;
            color: #222222;
            font-weight: bold;
            line-height: 40px;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 106px;
                    height: 106px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 106px;
                        height: 106px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                    .filename{
                        width: 106px;
                        font-size: 12px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        margin-top: 2px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
        }
        .table{
            width: 100%;
            max-width: 1430px;
        }
        .card{
            width: 100%;
            max-width: 1430px;
        }
        .btn{
            padding:10px 0;
            max-width: 1430px;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }


    .dialog{
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
        .template-footer{
            width: 100%;
            display: flex;
            padding-top:20px;
            justify-content: center;
        }
    }
</style>
